/**
 * DecorPlacementService — CRUD for a decor item's physical position on a
 * floor plan. Unlike DecorService (localStorage-cached), placements are
 * fetched fresh per floor plan and written straight through to the API —
 * there's no offline scenario worth caching drag positions for.
 */

import { DecorPlacement } from '../types/Decor';
import { apiGet, apiPost, apiPut, apiDelete, planningPath } from './PlanningApiClient';

export async function listDecorPlacements(floorPlanId: number): Promise<DecorPlacement[]> {
  const raw = await apiGet<{ placements: DecorPlacement[] }>(planningPath(`/decor-placements?floor_plan_id=${floorPlanId}`));
  return Array.isArray(raw?.placements) ? raw.placements : [];
}

export function createDecorPlacement(decorId: number, floorPlanId: number, x: number, y: number): Promise<DecorPlacement> {
  return apiPost<DecorPlacement>(planningPath('/decor-placements'), { decor_id: decorId, floor_plan_id: floorPlanId, x, y });
}

export function updateDecorPlacementPosition(id: number, x: number, y: number): Promise<DecorPlacement> {
  return apiPut<DecorPlacement>(planningPath(`/decor-placements/${id}`), { x, y });
}

export function deleteDecorPlacement(id: number): Promise<void> {
  return apiDelete(planningPath(`/decor-placements/${id}`));
}
